import { dealAxiosError } from "@/utils/other.js";
import axiosInstance from "../request";
/**
 * Fetch notifications list
 * @param {int} [page_size=10] Number of notifications per page, default is 10
 * @param {int} [page_index=1] The page number to fetch, default is the first page
 * @returns {Promise}
 */
export const fetchNotificationsList = async (page_index = 1,page_size = 10) => {
    try {
      const response = await axiosInstance.get('/notifications/list', {
        params: { page_size, page_index }
      });
      return response.data;
    } catch (error) { return dealAxiosError(error);
    }
  };
  
  /**
   * Mark a notification as read
   * @param {int} notification_id The ID of the notification to mark as read
   * @returns {Promise}
   */
  export const markAsReadNotification = async (notification_ids) => {
    try {
      const response = await axiosInstance.post('/notifications/read', { notification_ids:notification_ids });
      return response.data;
    } catch (error) { return dealAxiosError(error);
    }
  };